import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { localStorage } from '@mdc/services';
import PropTypes from 'prop-types';

import './LanguageSelector.scss';

const LanguageSelector = ({ selectorClassNames }) => {
    const availableLanguages = [
        { code: 'en-US', name: 'English' },
        { code: 'ja-JP', name: '日本語' },
    ];

    const { ready, i18n } = useTranslation();
    const [activeLanguage, setActiveLanguage] = useState({});

    useEffect(() => {
        const activeLang = availableLanguages.find((l) => l.code === i18n.language);
        setActiveLanguage(activeLang);
    }, []);

    if (!ready) {
        return null;
    }

    const changeLanguage = (langCode) => {
        if (langCode !== activeLanguage.code) {
            i18n.changeLanguage(langCode).then(() => {
                setActiveLanguage(availableLanguages.find((l) => l.code === langCode));
                localStorage.setItem('locale', langCode);
            });
        }
    };

    const dropdownItems = availableLanguages.map((lang) => {
        let activeClasses = classNames({
            activeLanguage: (activeLanguage.code === lang.code),
        });
        return (<Dropdown.Item
            className={activeClasses}
            key={lang.code}
            onClick={changeLanguage.bind(null, lang.code)}
        >
            {lang.name}
        </Dropdown.Item>);
    });

    return (
        <Dropdown
            className={selectorClassNames}
            size="sm"
            alignRight
        >
            <Dropdown.Toggle id="language-dropdown">
                {activeLanguage.name}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {dropdownItems}
            </Dropdown.Menu>
        </Dropdown>
    );
};

LanguageSelector.defaultProps = {
    selectorClassNames: 'language-selector'
};

LanguageSelector.propTypes = {
    selectorClassNames: PropTypes.any
};

export default LanguageSelector;
